import { Controller } from 'stimulus'
import { useBusItem } from '../mixins/useBusItem.js'

export default class extends Controller {
  static values = {
    busItemId: String
  }

  connect() {
    useBusItem(this)
  }

  get inputsSerialized() {
    const inputs = $(this.element.querySelectorAll('input, select, textarea'))
    return inputs.serialize()
  }

  get inputsData() {
    return $.deparam(this.inputsSerialized)
  }

  disconnect() {
    this.removeFromBus()
  }
}
